import { useHttpClient } from '@/common/api/httpClient';
import type { ReportType } from 'shared/reports/domain/reportType';

export interface ToggleReportRequest {
  reportType: ReportType;
  enabled: boolean;
}

export function useToggleReportApi() {
  return {
    execute,
  };

  async function execute(requestData: ToggleReportRequest) {
    const httpClient = useHttpClient();
    const headers = httpClient.defaultHeaders();

    const request = new Request(httpClient.siteUrl('report/manage'), {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData),
    });

    const response = await httpClient.execute(request);
    return response.ok;
  }
}
